import styled from "styled-components";

export const Table = styled.table<{
  lastChild?: boolean;
  beforeLastChild?: boolean;
}>`
  width: 100%;
  border-spacing: 0px;
  overflow-x: auto; /* Add horizontal scrollbar when content overflows */

  border-spacing: 0px;
  thead {
    background: rgba(229, 239, 242, 0.7);
    tr {
      background: rgba(229, 239, 242, 0.7);

      th:last-child {
      }
    }
  }
  tbody {
    tr {
      border-bottom: 1px solid #cfd2e8;

      td {
      }
      &:last-child {
        background: ${({ lastChild }) =>
          lastChild ? "#fff" : "rgba(229, 239, 242, 0.7)"};
        td {
          font-weight: ${({ lastChild }) => (lastChild ? "normal" : "bolder")};
          font-size: ${({ lastChild }) => (lastChild ? "0.875rem" : "1rem")};
        }
      }
    }
  }
`;

export const InputContainer = styled.div`
  width: 40%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  input {
    height: 2.5rem;
    width: 2.5rem !important;
    background: #edf4f6;
    border: 1px solid #b6bfdc;
    margin: 0 0.5rem;
  }
`;

export const SavedCards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
`;

export const CardContainer = styled.section`
  color: #101e8e;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #edf4f6;
  border: 1px solid #b6bfdc;
  padding: 1rem;
  &:hover {
    background: #fff;
  }
`;

export const CC = styled.img``;

export const Label2 = styled.label`
    --border-default: #bbbbc1;
    --border-hover: #9898a3;
    --active: #bae0bd;
    --active-tick: #fff !important;
    display: block;
    width: 18px;
    height: 18px;
    cursor: pointer;
    position: relative;
    -webkit-tap-highlight-color: transparent;
    svg {
      display: block;
      position: absolute;
    }
    input {
      display: block;
      outline: none;
      border: none;
      padding: 0;
      margin: 0;
      -webkit-appearance: none;
      width: 18px;
      height: 18px;
      padding:11px !important;
      border-radius: 50% / 50%;
      box-shadow: inset 0 0 0 1.5px var(--border, var(--border-default));
      background: var(--background, transparent);
      transition: background 0.25s linear, box-shadow 0.25s linear;
      & + svg {
        width: 21px;
        height: 17px;
        left: -1px;
        top: 5px;
        color: var(--active-tick) !important;
        .tick {
          stroke-dasharray: 20;
          stroke-dashoffset: var(--stroke-dashoffset, 20);
          transition: stroke-dashoffset 0.2s;
          &.mask {
            stroke: var(--active-tick);
          }
        }
        & + svg {
          width: 11px;
          height: 11px;
          fill: none;
          stroke: var(--active);
          stroke-width: 1.25;
          stroke-linecap: round;
          top: -6px;
          right: -1px;
          stroke-dasharray: 4.5px;
          stroke-dashoffset: 13.5px;
          pointer-events: none;
          animation: var(--animation, none) 0.2s ease 0.175s;
        }
      }
      &:checked {
        --background: var(--active);
        --border: var(--active);
        & + svg {
          --stroke-dashoffset: 0;
          & + svg {
            --animation: check;
          }
        }
      }
    }
    &:hover {
      input {
        &:not(:checked) {
          --border: var(--border-hover);
        }
      }
    }
  }

  @keyframes check {
    100% {
      stroke-dashoffset: 4.5px;
    }
  }

  html {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  * {
    box-sizing: inherit;
    &:before,
    &:after {
      box-sizing: inherit;
    }
`;
